
export enum DiagnosisNameEnum {
    RETT_SYNDROME = 'rett_syndrome',
    RETT_LIKE_SYNDROME = 'rett_like_syndrome',
    MECP2_DUPLICATION = 'mecp2_duplication'
}

export enum DiagnosisTypeEnum {
    MECP2_MUTATION = 'mecp2_mutation',
    FOXG1_MUTATION = 'foxg1_mutation',
    CDKL5_MUTATION = 'cdkl5_mutation',
    UNKNOWN_MUTATION = 'unknown_mutation'
}